<template>
  <v-card>
    <router-view :key="$route.fullPath"></router-view>
  </v-card>
</template>
<script>
export default {
  beforeRouteEnter (to, from, next) {
    document.title = 'CRM'
    next()
  }
}
</script>
